module.exports = __webpack_public_path__ + "static/media/carpet.c4cbfa79.svg";